export default {
    generateContentModal: {
        title: 'Genera contenuti',
        type: 'Tipo',
        typePlaceholder: 'Seleziona tipo',
        typeEmptyError: 'Per favore seleziona il tipo',
        context: 'Contesto',
        contextPlaceholder: 'Seleziona contesto',
        contextEmptyError: 'Per favore seleziona il contesto',
        contentTitle: 'Titolo del contenuto',
        contentTitlePlaceholder: 'Aggiungi il tema dei tuoi contenuti.',
        contentTitleEmptyError: 'Inserisci il titolo, per favore.',
        contentTitleInvalidError: 'Inserisci un titolo valido, per favore.',
        contentTitleNumberError: 'Inserisci un titolo che inizi con una lettera, per favore',
        description: 'Fornisci una breve descrizione del contenuto.',
        descriptionPlaceholder: 'Aggiungi la descrizione del tuo contenuto in 2-3 righe',
        descriptionEmptyError: 'Per favore inserisci la descrizione',
        descriptionInvalidError: 'Per favore, inserisci una descrizione valida',
        addKeywords: 'Aggiungi parole chiave',
        addKeywordsEmptyError: 'Si prega di inserire le parole chiave',
        writingTone: 'Tono di scrittura',
        writingTonePlaceholder: 'Seleziona il tono di scrittura',
        writingToneEmptyError: 'Si prega di selezionare il tono di scrittura',
        numberOfVariations: 'Numero di variazioni',
        numberOfVariationsEmptyError: 'Scegli il numero di variazione, per favore',
        numberOfVariationsInvalidError: 'Puoi generare un massimo di 5 variazioni e un minimo di 1',
        generate: 'generare',
        additionalOptions: 'Opzioni aggiuntive',
        clear: 'Chiaro',
        writingToneOptions: {
            funny: 'divertente',
            casual: 'Casual',
            excited: 'eccitato',
            professional: 'Professionale',
            witty: 'Spiritoso',
            sarcastic: 'Sarcastico',
            feminine: 'Femminile',
            masculine: 'Maschile',
            bold: 'Audace',
            dramatic: 'drammatico',
            grumpy: 'Brontolone',
            secretive: 'riservato',
            respectful: 'Rispettoso',
            persuasive: 'persuasivo',
        },
        contextOptions: {
            promotional: 'promozionale',
            introduction: 'Introduzione',
            couponDiscount: 'Coupon/Sconto',
            recurringNewsletter: 'Newsletter ricorrente',
            testimonial: 'Testimone',
            coldOutreach: 'Prospecting freddo',
            contentGiveaway: 'Contenuto/Regalo',
            other: 'Altro',
        },
        typeOptions: {
            outline: 'Sommario',
            introduction: 'Introduzione',
            section: 'Sezione',
        },
        customLengthOfContentPlaceholder: 'Aantal woorden (max 900)',
        lengthOfContentPlaceholder: 'Selecteer inhoudslengte',
        lengthOfContent: 'Lengte van de inhoud',
        customLengthOfContent: 'Lunghezza personalizzata',
        smallContent: 'Klein',
        mediumContent: 'Medio',
        largeContent: 'Grande',
        customContentLength: 'Aangepaste lengte (50 - 900 woorden)',
        lengthOfContentError: 'Seleziona la lunghezza del contenuto, per favore',
        customLengthError: 'Onjuiste waarde',
        lengthOfContentTooltip: 'Imposta la lunghezza del contenuto che verrà generato in base alla descrizione dei suggerimenti',
    },
};
